import { SKIPSCREEN_CALENDAR_REFRESH_EVENT } from './realtimeEvents';

/** Notify calendar views to refetch meeting requests and slots. */
export function refreshCalendarRealtime(): void {
  window.dispatchEvent(new Event(SKIPSCREEN_CALENDAR_REFRESH_EVENT));
}
